module.exports = __webpack_public_path__ + "static/img/123.ae6f06c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/123.png
// module id = 4cxW
// module chunks = 0